import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Form, Input, message } from 'antd'
import { inject } from 'mobx-react'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

const GET_SETTINGS = gql`
    query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
    }
`

const SET_MUNICIPAL_ADDRESS = gql`
    mutation setMunicipalAddress(
        $input: JSON
    ) {
        setMunicipalAddress(
            input: $input
        )
    }
`

const MunicipalAddress = (props) => {
	const { 
		AuthStore, form, saveMunicipalAddress, ...rest 
	} = props
	const { getFieldDecorator, resetFields } = form
	const { barangay_uid } = AuthStore
	const [isSaving, setSaving] = useState(false)
    
	const handleSubmit = (e) => {
		e.preventDefault()
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
            
			values = Object.assign({}, values, { barangay_uid, code: 'MUNICIPAL_ADDRESS' })

			message.loading({ key: 'set_municipal_address', content: 'Saving Municipal address, please wait..' })
			setSaving(true)
			saveMunicipalAddress(values).then((response) => {
				setSaving(false)
				message.success({ key: 'set_municipal_address', content: 'Municipal address successfully saved.' })
			}).catch(err => {
				setSaving(false)
				console.log('error saving municipal address')
				message.error({ key: 'set_municipal_address', content: err.message.replace('GraphQL error:', '') })
				resetFields()
			})
		})
	}

	return (
		<Query query={GET_SETTINGS} variables={{ barangay_uid, code: 'MUNICIPAL_ADDRESS' }}>
			{({ loading, error, data }) => {

				const mSetting = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				return (
					<div style={{ position: 'relative' }}>
						<Form onSubmit={handleSubmit}>
							<Form.Item label='Province Name'>
								{ getFieldDecorator('municipal_address', {
									initialValue: (mSetting) ? mSetting.value : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input style={{ width: '90%' }} placeholder='Enter Municipal Address'/>
								)}
							</Form.Item>
						</Form>
						<button disabled={isSaving} onClick={handleSubmit} style={{ position: 'absolute', top: '49px', right: '1px' }} type="button" className="btn btn-primary waves-effect waves-light">Save</button>
					</div>
				)
			}}
		</Query>
	)
}

const composed = compose(
	Form.create({ name: 'form-municipal-address' }),
	inject('AuthStore'),
	graphql(SET_MUNICIPAL_ADDRESS, {
		props({ mutate }) {
			return {
				saveMunicipalAddress(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangaySettingsByCode']
					})
				}
			}
		}
	}),
)

export default composed(MunicipalAddress)